import {useEffect, useId, useState} from "react";
import {ThinCloseIcon, TomansIcon} from "../../../components/icons/material-icons";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";
import {NumberToPersianLetters} from "../../../components/techaran/money";

export const ParentsMaxPayPerDayEditModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    currentMax: number
}) => {
    const [max, setMax] = useState(0);
    useEffect(() => {
        const isActive = props.active;
        const _max = props.currentMax;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            setMax(_max);
            setHasLimit(_max > 0);
        } else
            document.body.classList.remove('body-no-scroll');
    }, [props.active, props.currentMax]);
    const maxId = useId();
    const saveMax = () => {
        const _max = max;
        if (_max < 0) {
            ShowSnackbar(
                'لطفا مبلغ برداشت را صحیح وارد کنید.',
                'باشه',
                5000,
            );
            return;
        }
        const _hasMax = hasLimit;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/store/edit-max',
            {
                m: _hasMax ? _max : '0',
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                ShowSnackbar(
                    'حداکثر خرید روزانه از فروشگاه تغییر یافت.',
                    'باشه',
                    5000,
                );
                props.onDone(_max);
                props.closeHandler();
            },
            () => {
                HideProgressLoading();
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    const [hasLimit, setHasLimit] = useState(false);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div>
                        <b>ویرایش حداکثر خرید روزانه</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="setting-store-max">
                        <label htmlFor={maxId} className="f-roboto">
                            حداکثر مبلغ قابل برداشت توسط دانش‌آموز در روز:
                        </label>
                        <button className={"techaran-switch" + (hasLimit ? ' active' : '')}
                                onClick={() => setHasLimit(v => !v)}
                                style={{paddingTop: 20, paddingBottom: 20}}>
                            <i><b/></i>
                            <span>
                                {hasLimit ? 'دارای محدودیت' : 'بدون محدودیت'}

                            </span>
                        </button>
                        {
                            hasLimit ?
                                <>
                                    <div className="toman-input">
                                        <input type="number" className="form-control f-roboto"
                                               id={maxId}
                                               step={500}
                                               min={0}
                                               value={max}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setMax(parseInt(t));
                                               }}
                                        />
                                        <em><TomansIcon/></em>
                                    </div>
                                    <span>{NumberToPersianLetters(max)} تومان</span>
                                </>
                                : null
                        }
                        <div className="d-flex justify-content-end" style={{marginTop: 20}}>
                            <button className="btn-pay" onClick={saveMax}>
                                <b>ذخیره</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};